const uniq = array => Array.from(new Set(array).values());

export default uniq;
